export default "__VITE_ASSET__Bz_Necji__"